/**
 * CWSアイコンファイル適用期間更新
 *
 * @export UpdateCwsIconFilePeriodVo
 * @class UpdateCwsIconFilePeriodVo
 */
export class UpdateCwsIconFilePeriodVo {
    constructor(
        public iconCode: string,
        public iconCodeBranch: string,
        public startOrderCode: string,
        public endOrderCode: string,
    ) {}
}
